import { Injectable } from '@angular/core';
import { DomainEventBus, DomainEvent, DomainEventType } from '../events/domain-event-bus';
import { filter } from 'rxjs/operators';
import { metrics, trace } from '@opentelemetry/api';
import { logs, SeverityNumber } from '@opentelemetry/api-logs';
import { OTEL_SERVICE_NAME } from './telemetry.constants';

@Injectable({ providedIn: 'root' })
export class NotFoundPageTelemetryService {
  private meter = metrics.getMeter(OTEL_SERVICE_NAME);
  private tracer = trace.getTracer(OTEL_SERVICE_NAME);
  private logger = logs.getLogger(OTEL_SERVICE_NAME);
  private pageShown = this.meter.createCounter('ui_not_found_page_shown_total', {
    description: 'Total times the 404 not-found page was shown'
  });

  constructor(bus: DomainEventBus) {
    bus.events$.pipe(filter((e) => e.type === DomainEventType.NotFoundPageShown)).subscribe((e) => {
      const ev = e as Extract<DomainEvent, { type: typeof DomainEventType.NotFoundPageShown }>;
      this.pageShown.add(1);

      this.tracer.startActiveSpan('ui.not_found.page', (span) => {
        try {
          span.setAttribute('session.id', ev.sessionId);
        } catch {}
        if (ev.url) span.setAttribute('url', ev.url);

        const spanContext = span.spanContext();
        const traceId = spanContext.traceId;
        const spanId = spanContext.spanId;

        this.logger.emit({
          body: 'UI not-found page shown',
          severityNumber: SeverityNumber.INFO,
          severityText: 'INFO',
          attributes: {
            'session.id': ev.sessionId,
            url: ev.url,
            'trace.id': traceId,
            'span.id': spanId
          }
        });

        span.end();
      });
    });
  }
}
